import { z } from 'zod';
import { PASSWORD_VALIDATION_KEYS } from 'app/components/PasswordValidationPoints';

const ValidationScheme = {
  Email: z
    .string()
    .trim()
    .min(1, { message: 'validation.emailRequired' })
    .email({ message: 'validation.emailInvalid' }),
  RequiredString: (
    options: { message: string } = {
      message: 'validation.fieldRequired',
    },
  ) =>
    z.string().trim().min(1, {
      message: options.message,
    }),
  ValidPassword: z
    .string()
    .trim()
    .min(8, { message: PASSWORD_VALIDATION_KEYS.length })
    .refine((password) => /[A-Z]/.test(password), {
      message: PASSWORD_VALIDATION_KEYS.uppercase,
    })
    .refine((password) => /[a-z]/.test(password), {
      message: PASSWORD_VALIDATION_KEYS.lowercase,
    })
    .refine((password) => /[0-9]/.test(password), {
      message: PASSWORD_VALIDATION_KEYS.number,
    })
    .refine((password) => /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/.test(password), {
      message: PASSWORD_VALIDATION_KEYS.symbol,
    }),
};

export default ValidationScheme;
